import {
  DeleteType,
  FormPipe,
  HydraulicType,
  SearchHydraulic,
} from '@/types/hydraulic'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const hydraulicDataConfig = {
  getAll(searchParams: SearchHydraulic) {
    const url = '/api/pipe'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(interfaceId: Number, id: Number): Promise<{ data: HydraulicType }> {
    const url = `/api/pipe/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  create(payload: FormPipe) {
    const url = '/api/pipe'
    return axiosClient.post(url, payload)
  },

  update(payload: FormPipe) {
    const url = 'api/pipe'
    return axiosClient.put(url, payload)
  },

  delete(payload: DeleteType) {
    const url = `./api/pipe?interfaceId=${payload.interfaceId}&&id=${payload.id}`
    return axiosClient.delete(url)
  },
}

export default hydraulicDataConfig
